function t(r) {
  return r == null || typeof r == "string" && r.trim() === "" ? null : Number(r);
}
function e(r) {
  return r.includes(".") && (/^(-)?\d+.*(\.|0)$/.test(r) || /^-?\d*$/.test(r)) || r === "-" || r === "-0";
}
function i(r) {
  return r == null ? !0 : !Number.isNaN(r);
}
function u(r, n) {
  return typeof r != "number" ? "" : n === void 0 ? String(r) : r.toFixed(n);
}
function f(r) {
  if (r === null)
    return null;
  if (typeof r == "number")
    return r;
  {
    const n = Number(r);
    return Number.isNaN(n) ? null : n;
  }
}
export {
  u as format,
  e as isWipValue,
  t as parse,
  f as parseNumber,
  i as validator
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/input-number/src/utils.js
// module id = 1701
// module chunks = 67